<template>

  <div class="dapp-rank">

    <DAppSearchBox v-if="showSearchBox" class="dapp-search mb-3"></DAppSearchBox>

    <div class="dapp-filter">

      <!-- category -->
      <a-select :value="currentCategoryId" @change="handleCategoryChange">
        <a-select-option value="all">{{ $t('allCategories') }}</a-select-option>
        <a-select-option v-for="cat in categories" :value="cat.key" :key="cat.key">{{ cat.name }}</a-select-option>
      </a-select>

      <!-- platform -->
      <a-select :value="currentPlatform" @change="handlePlatformChange">
        <a-select-option v-for="platform in platforms" :value="platform.name"
                         :key="platform.key" :disabled="platform.enable === false"
        >{{ platform.name }}{{ platform.enable ? '' : $t('comingSoon')}}
        </a-select-option>
      </a-select>

      <!-- sort -->
      <a-select :value="sort" @change="handleSortChange">
        <a-select-option v-for="s in sorts" :value="s" :key="s">
          {{ $t('column.' + s) }}
        </a-select-option>
      </a-select>

    </div>

    <DAppGroup class="dapp-rank-card-list"
               :list="dapps" :bigger-item="true">
      <template slot="item" slot-scope="item">
        <DAppDetailCard :dapp="item.data"/>
      </template>
    </DAppGroup>

    <DAppRowList class="dapp-rank-table"
                 :dapps="dapps"
                 :sort="sort"
                 :on-click-handler="handleSortChange">
    </DAppRowList>

    <DAppPagination class="dapp-rank-pagination"
                    :total="pagination.total"
                    :current="pagination.current"
                    :on-click-handler="handlePageChange">
    </DAppPagination>

  </div>

</template>

<script>

  import * as api from './../api'
  import * as constant from './../const'
  import DAppRowList from './DAppRowList'
  import DAppPagination from './DAppPagination'
  import DAppSearchBox from './DAppSearchBox'
  import DAppGroup from './DAppGroup'
  import DAppDetailCard from './DAppDetailCard'
  import * as router from '../router'

  // 数据流向：用户操作 --> 修改Route参数 --> 加载数据 --> 刷新ViewModel

  export default {
    name: 'DAppRankNew',
    props: ['showSearchBox'],
    components: {DAppGroup, DAppPagination, DAppRowList, DAppSearchBox, DAppDetailCard},
    data () {
      return {
        loading: false,
        dapps: [],
        sort: 'user1d',
        sorts: ['user1d', 'tx1d', 'value1d', 'user7d', 'tx7d', 'value7d'],
        pagination: {
          pageSize: 20,
          current: 1,
          total: 0,
          showTotal: total => `Total ${total} items`
        },
        categories: [],
        currentCategoryId: '',
        platforms: constant.platforms,
        currentPlatform: constant.defaultPlatform
      }
    },
    mounted () {
      console.log('dapp-list mounted')
      api.getCategories().then(data => {
        this.categories = data
      })
      this.fetch()
    },
    watch: {
      $route: function () {
        this.fetch()
      }
    },
    methods: {
      handleSortChange (key) {
        router.replaceQuery({sort: key, page: 1})
      },
      handlePageChange (page) {
        router.replaceQuery({page: page})
      },
      handleCategoryChange (id) {
        if (id && id !== this.currentCategoryId) {
          this.currentCategoryId = id
          router.replaceQuery({category: id, page: 1})
        }
      },
      handlePlatformChange (platform) {
        if (platform && platform !== this.currentPlatform) {
          this.currentPlatform = platform
          router.replaceQuery({platform: platform, page: 1})
        }
      },
      fetch: function () {

        this.loading = true

        // 从route读取参数
        const limit = 20
        const page = parseInt((this.$route.query && this.$route.query['page']) || 1)
        const params = {
          category: this.$route.query['category'] || 'all',
          keywords: this.$route.query['keywords'],
          page: page,
          limit: limit,
          offset: (page - 1) * limit,
          sort: this.$route.query['sort'] || 'user1d',
          order: this.$route.query['order'] || 'desc'
        }

        api.getDApps(params).then((data) => {

          const list = data.list

          // 设置index
          list.forEach((e, i) => {
            e.index = params.offset + i + 1
          })

          // 刷新页面展示
          this.pagination.current = params.page
          this.pagination.total = Math.ceil(data.total / limit)

          this.sort = params.sort
          this.currentCategoryId = params.category
          this.dapps = list
          this.loading = false
        }).catch((e) => {
          console.error(e)
          this.loading = false
        })
      },
    },
  }

  function replaceQuery (route, replace) {
    return {
      path: route.path,
      query: Object.assign({}, route.query, replace)
    }
  }

</script>

<style lang="scss" scoped>

  @import "./../utils";

  .dapp-rank {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .dapp-rank-card-list {
    width: 100%;
    @include respond-desktop {
      display: none;
    }
  }

  .dapp-rank-table {
    width: 100%;
    display: none;
    @include respond-desktop {
      display: block;
    }
  }

  .dapp-search {
    width: 100%;
    max-width: 600px;
  }

  .dapp-filter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    > * {
      width: 100%;
      margin: 5px;
      @include respond-desktop {
        width: 180px;
      }
    }
    @include respond-desktop {
      flex-direction: row;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/widgets/DAppRankNew.vue